import Button from "../../components/button";
import Input from "../../components/input";
import Navbar from "../../components/navbar";
import signIn from "../../assets/icons/signIn.svg";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showSuccessMessage } from "../../hooks/constants";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { userSignIn } from "../../hooks/local/reducer";

const SignIn = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();


      const loading = useSelector((state) => state.user.loading);
  document.title = `${loading? "Mosquepay" : "Sign in - Mosquepay"}`;

    const signInForm = useFormik({
      initialValues:{
        email: "",
        password: "",
      },
      validationSchema: Yup.object({
        email: Yup.string()
        .required("Your email address is required")
        .email("Please enter a valid email address"),
        password: Yup.string().required("Password is required")
      }),
      onSubmit: async(values, {resetForm}) => {
        const {email, password} = values;
        let signInData = {email, password};
        const {payload} = await dispatch(userSignIn(signInData));
        if(payload.status_code === "0") {
          showSuccessMessage("Signed in!");
          resetForm();
          // navigate("/dashboard");
          const redirectPath = location.state?.actionType === "createCampaign" ? "/dashboard/start-a-campaign" : "/dashboard";
          navigate(redirectPath);
        }
      }
    })

    return ( 
        <div className="bg-signInPattern bg-[length:24%]">
          <div className="bg-white/80 min-h-screen flex items-center pt-24 pb-16">
            {/* navbar */}
            <Navbar />
            <div className="px-4 md:px-12 grid grid-cols-1 lg:grid-cols-5 gap-4 w-full">
              <div className="bg-white rounded border lg:col-span-2 p-4 md:p-10">
               <p className="font-semibold">Sign in.</p>
               <p className="text-secondary leading-tight mt text-sm">Sign in to easily manage your campaigns.</p>
               <form onSubmit={signInForm.handleSubmit}  className="mt-6 grid gap-4">
                  <Input
                   type={"email"}
                   label={"Email address"}
                   placeholder={"Muhammad"}
                   name={"email"}
                   value={signInForm.values.email}
                   onChange={signInForm.handleChange}
                   onBlur={signInForm.handleBlur}
                   onError={signInForm.touched.email && signInForm.errors.email ? signInForm.errors.email : null}
                  />
                  <Input
                   type={"password"}
                   label={"Password"}
                   isPassword={"true"}
                   name={"password"}
                   value={signInForm.values.password}
                   onChange={signInForm.handleChange}
                   onBlur={signInForm.handleBlur}
                   onError={signInForm.touched.password && signInForm.errors.password ? signInForm.errors.password : null}
                  />
                 <div className="flex items-center justify-between">
                  <Button buttonText={"Sign in"} icon={signIn} loading={loading} otherStyles={"bg-black text-white"}/>
                  <Link to={"/forgot-password"} className="underline text-brandGreen ps-1">Forgot password?</Link>
                 </div>
               </form>
               <p className="mt-6">Don't have an account? <Link to={"/sign-up"} className="underline text-brandGreen ps-1">Sign up</Link></p>
              </div>
              <div className="lg:col-span-3 p-4 md:p-10">
                 <div className="h-full flex items-center">
                   <div className="text-center lg:text-start">
                     <p>“Those who spend their wealth in Allah’s cause are like grains of corn which produce seven ears, each bearing a hundred grains.”</p>
                     <p className="font-bold mt-2">Qur’an, 2:261</p>
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>
     );
}
 
export default SignIn;